import * as React from "react"

import { getClient } from '../../../api/graphql'
import { ApolloProvider } from "react-apollo";
import { Show } from "../../themes/Show";
import { PageLoader } from "../../shared/loaders/PageLoader";
import { ThemeShowQuery, variables, query } from "../../../api/queries/themes/show";
import { IntlProvider } from "react-intl";
import { Area, Theme } from "../../../types/types";
import { StartEnd } from "../../../utils/period_picker/PeriodPicker";
import { FocusedInputShape } from "react-dates";
import QuickFilterSubmit from "../../../api/quick_filter/submit";
import * as moment from 'moment';

type State = StartEnd & {
  focusedInput: FocusedInputShape
  readMoreOpen: boolean
  maxPeople: number
  filterDisabled: boolean
}

type Props = StartEnd & {
  slug: string
}

type SProps = StartEnd & {
  theme: Theme
}

class StatefullShowThemesContainer extends React.Component<SProps, State> {
  constructor(props:SProps) {
    super(props)
    this.state = {
      startDate: this.props.startDate ? moment(this.props.startDate, "DD-MM-YYYY") : null,
      endDate: this.props.endDate ? moment(this.props.endDate, "DD-MM-YYYY") : null,
      focusedInput: null,
      readMoreOpen: false,
      maxPeople: 1,
      filterDisabled: false,
    }
  }

  onFilterSubmit() {
    this.setState({filterDisabled: true}, async () => {
      await QuickFilterSubmit(this.state.startDate, this.state.endDate, this.state.maxPeople, this.props.theme.slugsForBooleanSearch)
      this.setState({filterDisabled: false})
    })
  }

  render() {
    return (
      <Show
        theme={this.props.theme}
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        focusedInput={this.state.focusedInput}
        onFocusChange={(fi) => this.setState({ focusedInput: fi})}
        onDatesChange={(range: StartEnd) => this.setState({...range})}
        filterDisabled={this.state.filterDisabled}
        onFilterSubmit={() => this.onFilterSubmit()}
        maxPeople={this.state.maxPeople}
        onMaxPeopleChange={(i) => this.setState({maxPeople: i})}
      />
    )
  }
}

export default (props: Props) : JSX.Element => (
  <IntlProvider locale={window.Gites.locale}>
    <ApolloProvider client={getClient()}>
      <ThemeShowQuery
        query={query()}
        variables={variables(props.slug)}
      >
        {({ loading, error, data}) => {
          if(loading) return <PageLoader />
          if(error) return <div>Something went wrong</div>
          return (
            <StatefullShowThemesContainer
              theme={data.theme}
              startDate={props.startDate}
              endDate={props.endDate}
            />
          )
        }}
      </ThemeShowQuery>
    </ApolloProvider>
  </IntlProvider>
)
